import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { createStyles, Dialog, IconButton, makeStyles, TextField, Theme } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { toEn } from 'convert-layout/ru';
import { toEn as fromKktoEn } from 'convert-layout/kk';
import { CustomerDto, OrderDto } from '../../../api/orders';
import Spin from '../../atoms/Spin/Spin';

interface Props {
    items: OrderDto[];
    open: boolean;
    onClose: () => void;
    onDeleteAll: () => void;
    onSelect: (item: OrderDto) => void;
    onSearch: (val: string) => Promise<boolean | undefined>;
    loading: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        removeAll: {
            color: theme.palette.error.main,
        },
        formControl: {
            minWidth: 120,
            width: '50%',
        },
        searchContainer: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        count: {
            marginLeft: 'auto',
        },
    })
);

const OrderDataListDialog = ({
    items,
    open,
    onClose,
    onDeleteAll,
    onSelect,
    onSearch,
    loading,
}: Props) => {
    const classes = useStyles();
    const [search, setSearch] = useState('');

    const handleSearch = (val: string) => {
        onSearch(val).then(() => { });
    };

    const handleSearchChange = (e: any) => {
        setSearch(toEn(fromKktoEn(e.target.value)));
    };

    const handleSearchKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            handleSearch(search);
            setSearch('');
        }
    };

    return (
        <Dialog open={open} fullWidth={true} maxWidth="lg" onClose={onClose}>
            <DialogTitle>Выбранные заявки</DialogTitle>
            <DialogContent>
                <Box className={classes.searchContainer}>
                    <TextField
                        label="Введите номер заявки"
                        fullWidth
                        value={search}
                        variant="outlined"
                        className={classes.formControl}
                        onChange={handleSearchChange}
                        onKeyDown={handleSearchKeyDown}
                        autoFocus
                    />
                    <h2 className={classes.count}>
                        Выбрано: <span>{items.length}</span>
                    </h2>
                </Box>

                <Box position={'relative'}>
                    {loading && <Spin />}
                    <TableContainer>
                        <Table size={'small'} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <Button className={classes.removeAll} onClick={onDeleteAll}>
                                            Удалить все
                                        </Button>
                                    </TableCell>
                                    <TableCell>Номер заявки</TableCell>
                                    <TableCell>Статус</TableCell>
                                    <TableCell>Регион</TableCell>
                                    <TableCell>Курьер</TableCell>
                                    <TableCell>Зона</TableCell>
                                    <TableCell>Отправитель</TableCell>
                                    <TableCell>Получатель</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.map((item, index) => (
                                    <TableRow key={index} hover={true}>
                                        <TableCell>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => onSelect(item)}
                                            >
                                                <DeleteIcon fontSize="large" />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>{item.order_number}</TableCell>
                                        <TableCell>{item.order_status?.description}</TableCell>
                                        <TableCell>{item.region?.description}</TableCell>
                                        <TableCell>
                                            {item.courier
                                                ? [
                                                    `${item.courier?.last_name} ${item.courier?.first_name}`,
                                                    item.courier?.phone_number,
                                                ].join(', ')
                                                : ''}
                                        </TableCell>
                                        <TableCell>
                                            {item.geozone_name}
                                        </TableCell>
                                        <TableCell>
                                            {item.customers
                                                .filter(
                                                    (c: CustomerDto) =>
                                                        c.relation_type !== 'RECEIVER'
                                                )
                                                .map((client: CustomerDto, clientIdx: number) => (
                                                    <span key={clientIdx}>
                                                        {`${client.customer?.name} ${client.customer?.surname || ''
                                                            }`}
                                                        , {client.customer?.phone_number}
                                                    </span>
                                                ))}
                                        </TableCell>
                                        <TableCell>
                                            {item.customers
                                                .filter(
                                                    (c: CustomerDto) =>
                                                        c.relation_type === 'RECEIVER'
                                                )
                                                .map((client: CustomerDto, clientIdx: number) => (
                                                    <span key={clientIdx}>
                                                        {`${client.customer?.name} ${client.customer?.surname || ''
                                                            }`}
                                                        , {client.customer?.phone_number}
                                                    </span>
                                                ))}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>OK</Button>
            </DialogActions>
        </Dialog>
    );
};

export default OrderDataListDialog;
